export const OpenDataCollectionValidationStatus = Object.freeze({
    OLD_STATUS: {id: "OLD_STATUS", value: null},
    DATA_SUBMISSION: {id: "DATA_SUBMISSION_IN_PROGRESS", value: "DATA_SUBMISSION_IN_PROGRESS"}
})